import Header49_wave from './Header49_wave'
export default Header49_wave
